/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import InputMask from 'react-input-mask';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { getGaleriaSecondByUser, getPlayerInfo, getResultadosByUser } from 'services/dashboard.service';
import { useAuth } from 'context/AuthContext';
import { ExtratoDetalheModal } from 'components/extrato-detalhe-modal';
import { useModal } from 'context/ModalContext';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Button from 'components/ui/button';
import {
  getMissaoEquipe,
  getMissaoEquipeEcoa,
  getMissaoGestor,
  getPointsHistory,
  getPointsSummary,
} from 'services/achievement.service';
import { PointItem } from 'components/point-item';
import { FormatNumber } from 'utils/helpers';
import { BsPlusLg } from 'react-icons/bs';
import ModalComment from 'components/modal-comment';
import Recognition from 'components/recognition';
import RecognitionReceived from 'components/recognitionReceived';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useLocation } from 'react-router-dom';
import ModalEdit from 'components/modal-edit';
import UserBadge from 'components/user-badge';
import { RealCycle } from 'types/user';
import Dimensions from './Component/Dimensions';
import CustomSelect from 'components/custom-select';
import { TbSearch } from 'react-icons/tb';
import { Summary } from './Component/Summary';
import { BiInfoCircle, BiMinus } from 'react-icons/bi';
import { PointReviewItem } from 'components/point-review-item';
import Timeline from './Component/Timeline';
import Tippy from '@tippyjs/react';
import { getLevelTitle } from 'services/utils';
import TabTitle from 'components/tab-title';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import { getMyPreference } from 'services/actionlog.service';

const menu = ['Resumo', 'Reconhecimentos', 'Realização <br /> Destaque', 'Ações ECOA', 'Ações de <br />Engajamento'];
const menuRede = ['Resumo', 'Reconhecimentos'];

const Tabs = ['Resumo', 'Reconhecimentos', 'Realização <br /> Destaque', 'Ações ECOA', 'Ações de <br />Engajamento'];
const TabsRede = ['Resumo', 'Reconhecimentos'];

interface TitleTabOptions {
  title: JSX.Element;
  hideFilter?: boolean;
  options: any;
  className?: string;
}

interface CyclePreferenceAttributes {
  task?: boolean;
  actions?: boolean;
  recognition?: boolean;
}

export default function Historico() {
  const [summaryList, setSummaryList] = useState<any>();
  const [list, setList] = useState<any[]>([]);
  const [sentList, setSentList] = useState<any[]>([]);
  const [pointsList, setPointsList] = useState<any[]>();
  const [culturaList, setCulturaList] = useState<any[]>();
  const [galeriaList, setGaleriaList] = useState<any[]>();
  const [options, setOptions] = useState<any>([]);

  const [missionList, setMissionList] = useState<unknown[]>();
  const [missionListEcoa, setMissionListEcoa] = useState<unknown[]>();

  const { user, userInfo, currentCycle, realCycle, cycleSelected } = useAuth();
  const { showModal } = useModal();
  const location = useLocation();
  const navigate = useNavigate();

  const [isGestor, setIsGestor] = useState(false);
  const searchRef = useRef<any>();

  const [loadingSummaryList, setLoadingSummaryList] = useState(true);
  const [loadingList, setLoadingList] = useState(true);
  const [loadingSentList, setLoadingSentList] = useState(true);
  const [loadingPointsList, setLoadingPointsList] = useState(true);
  const [loadingMissionList, setLoadingMissionList] = useState(true);
  const [loadingMissionListEcoa, setLoadingMissionListEcoa] = useState(true);
  const [loadingCulturaList, setLoadingCulturaList] = useState(true);
  const [loadingGaleriaList, setLoadingGaleriaList] = useState(true);

  const [recognitionTab, setRecognitionTab] = useState<'RECEIVED' | 'SENDED'>('RECEIVED');

  const [showSummary, setShowSummary] = useState(false);
  const [summaryData, setSummaryData] = useState<{
    title?: string;
    data: any;
    type?: string;
  }>();

  const [activeEditModal, setActiveEditModal] = useState<{
    message: string;
    id: string;
  } | null>();
  const [editMessage, setEditMessage] = useState<{
    message: string;
    id: string;
  } | null>();

  const [activeTab, setActiveTab] = useState(0);

  const [filter, setFilter] = useState({});
  const [realCycleFilter, setRealCycleFilter] = useState<any>();
  const [cyclePreference, setCyclePreference] = useState<CyclePreferenceAttributes | null>(null);

  function handleDetail(item: any) {
    showModal('extrato-detalhe', item);
  }

  function getMissaoDestaque() {
    if (isGestor) {
      const valoracao = summaryList?.missao_destaque_gestor || 0;
      const participacao = summaryList?.missao_destaque_equipe || 0;
      return FormatNumber(valoracao + participacao);
    } else {
      return FormatNumber(summaryList?.missao_destaque_equipe);
    }
  }

  const title = useMemo(() => {
    switch (activeTab) {
      case 0:
        return (
          <>
            Seu Extrato <span className="text-md lg:text-[22px] font-bold text-yellow">Joga Junto BB</span>
          </>
        );
      case 1:
        return <>Reconhecimentos</>;
      case 2:
        return (
          <>
            Realizações Destaque{' '}
            <span className="text-xl lg:text-[22px] font-bold text-yellow ">({missionList?.length || 0})</span>
          </>
        );
      case 3:
        return (
          <>
            Ações ECOA <span className="text-xl lg:text-[22px] font-bold text-yellow ">({missionListEcoa?.length || 0})</span>
          </>
        );

      case 4:
        return (
          <>
            Ações de Engajamento{' '}
            <span className="text-xl lg:text-[22px] font-bold text-yellow ">({pointsList?.length || 0})</span>
          </>
        );

      default:
        return <></>;
    }
  }, [activeTab, missionList, pointsList]);

  useEffect(() => {
    async function loadData() {
      const playerInfo = userInfo;

      if (playerInfo) {
        setIsGestor(
          playerInfo.tipo_ro === 'GERENCIAL' ||
            playerInfo.funcao === 'DIRETOR' ||
            (typeof playerInfo.mad_dupla_tipo_ro === 'string' && playerInfo.mad_dupla_tipo_ro === 'GERENCIAL'),
        );
      }
    }

    if (user && realCycle) {
      initFilter();
      loadData();
    }
  }, [user, realCycle]);

  function initFilter() {
    if (!!realCycle) {
      const _cycles = realCycle.map((item: any) => {
        item.label = item.title;
        item.value = item._id;
        return item;
      });

      setOptions(_cycles);
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const active = searchParams.get('active');
    const sub = searchParams.get('sub') as 'RECEIVED' | 'SENDED';

    if (active) {
      setActiveTab(Number(active));
      searchParams.delete('active');
      const newUrl = window.location.pathname + '?' + searchParams.toString();
      window.history.replaceState({}, '', newUrl);

      if (sub) {
        setRecognitionTab(sub);
        searchParams.delete('sub');
        const newUrl = window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({}, '', newUrl);
      }
    }
  }, [location]);

  useEffect(() => {
    setShowSummary(false);
    setSummaryData(undefined);
  }, [activeTab]);

  useEffect(() => {
    async function loadData() {
      try {
        if (activeTab === 0) {
          const data = await getPointsSummary(user?._id, currentCycle?.date_start, currentCycle?.date_finish, filter);
          setSummaryList(data);

          const preferenceData = await getMyPreference(realCycleFilter?.value);

          if (!Array.isArray(preferenceData) || preferenceData.length === 0) {
            setCyclePreference(null);
          } else {
            const latestPreference = preferenceData[0];
            setCyclePreference(latestPreference?.attributes || null);
          }

          setLoadingSummaryList(false);
        } else if (activeTab === 1) {
        } else if (activeTab === 2) {
          setLoadingMissionList(true);
          const dataGestor = await getMissaoGestor(user?._id, realCycleFilter?.value);
          const dataEquipe = await getMissaoEquipe(user?._id, realCycleFilter?.value, filter);
          setMissionList([...dataGestor, ...dataEquipe]);

          setLoadingMissionList(false);
        } else if (activeTab === 3) {
          setLoadingMissionListEcoa(true);
          const dataEquipe = await getMissaoEquipeEcoa(user?._id, realCycleFilter?.value, filter);
          setMissionListEcoa(dataEquipe);

          setLoadingMissionListEcoa(false);
        } else if (activeTab === 4) {
          setLoadingPointsList(true);
          const data = await getPointsHistory(user?._id, '', '', filter);

          setPointsList(data);
          setLoadingPointsList(false);
        }
      } catch (e) {}
    }

    if (user && !!currentCycle && !!realCycleFilter) {
      loadData();
    }
  }, [user, activeTab, searchRef, currentCycle, filter]);

  useEffect(() => {
    if (user?.extra.rede) {
      setActiveTab(1);
    }
  }, [user]);

  function setActiveTabFiltered(index: number) {
    if (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && index === 2 && userInfo.ecoa) {
      setActiveTab(3);
      return;
    }

    if (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && index === 2 && !userInfo.ecoa) {
      setActiveTab(4);
      return;
    }

    if (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && index === 3 && userInfo.ecoa) {
      setActiveTab(4);
      return;
    }

    if (userInfo?.tipo_de_acordo === 'HIBRIDO' && index === 3 && !userInfo.ecoa) {
      setActiveTab(4);
      return;
    }

    setActiveTab(index);
  }

  function getActiveTabFiltered(index: number) {
    if (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && index === 2 && userInfo.ecoa) {
      return activeTab === 3;
    }

    if (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && index === 2 && !userInfo.ecoa) {
      return activeTab === 4;
    }

    if (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && index === 3 && userInfo.ecoa) {
      return activeTab === 4;
    }

    if (userInfo?.tipo_de_acordo === 'HIBRIDO' && index === 3 && !userInfo.ecoa) {
      return activeTab === 4;
    }

    return activeTab === index;
  }

  function scrollTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  function showPreferenceMessage(type: keyof CyclePreferenceAttributes) {
    return cyclePreference?.[type] === false;
  }

  const EmptyResult = () => {
    return (
      <>
        <div className="space-y-2 flex justify-center">
          <p className="text-white font-bold text-center text-2xl" tabIndex={0}>
            Não há registros para esse ciclo.
          </p>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (cycleSelected) {
      if (cycleSelected.version) {
        navigate(`/${cycleSelected.version}/extrato`);
      } else {
        navigate(`/extrato`);
      }
    }
  }, [cycleSelected]);

  return (
    <>
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex items-center justify-between mb-10">
          <div className="flex flex-ro items-center space-x-3 ">
            <div>
              <Link to="../" tabIndex={-1}>
                <button
                  className="rounded-full bg-purple flex justify-center items-center p-1"
                  tabIndex={0}
                  aria-label="Botão de voltar"
                >
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>
            </div>
            <h1 className="text-xl lg:text-3xl" tabIndex={0}>
              Extrato Completo
            </h1>
          </div>
        </div>

        {options?.length > 0 && (
          <TabTitle
            title={title}
            options={options}
            key={1}
            onCallBack={e => [setShowSummary(false), setFilter({ ...filter, ...{ cycleId: e?.value } }), setRealCycleFilter(e)]}
          />
        )}

        {!user?.extra.rede ? (
          <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 hidden lg:flex">
            {Tabs.filter(e => (userInfo?.tipo_de_acordo === 'PREDEFINIDO' && e === 'Realização <br /> Destaque' ? false : e))
              .filter(e => (!userInfo?.ecoa && e === 'Ações ECOA' ? false : e))
              .map((item: string, index: number) => (
                <button
                  aria-label={`${getActiveTabFiltered(index) ? 'selecionado' : ''}  ${item}`} // eslint-disable-line
                  className={`${
                    getActiveTabFiltered(index) ? 'bg-slate-blue' : 'bg-maastricht-blue'
                  } w-6/12 h-[86px] text-xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-all`}
                  onClick={() => [setActiveTabFiltered(index)]}
                  dangerouslySetInnerHTML={{
                    __html: item,
                  }}
                ></button>
              ))}
          </div>
        ) : (
          <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 hidden lg:flex">
            {TabsRede.map((item: string, index: number) => (
              <button
                aria-label={`${activeTab === index ? 'selecionado' : ''}`}
                className={`${
                  activeTab === index ? 'bg-slate-blue' : 'bg-maastricht-blue'
                } w-6/12 h-[86px] text-xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-all`}
                onClick={() => [setActiveTab(index)]}
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              ></button>
            ))}
          </div>
        )}

        <div className="flex justify-between items-center lg:hidden mb-10">
          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={activeTab < 1}
            onClick={() => setActiveTab(activeTab - 1)}
          >
            <IoIosArrowBack className={`text-grey-dark ${activeTab === 0 && 'bg-opacity-5'}}`} size={24} />
          </Button>

          <p
            className="text-xl font-bold text-yellow text-center"
            dangerouslySetInnerHTML={{
              __html: !user?.extra.rede ? menu[activeTab] : menuRede[activeTab],
            }}
          ></p>

          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={activeTab > 3}
            onClick={() => setActiveTab(activeTab + 1)}
          >
            <IoIosArrowForward className={`text-grey-dark ${activeTab > 0 && 'opacity-5'}}`} size={24} />
          </Button>
        </div>

        {activeTab === 0 && (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingSummaryList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingSummaryList && (
                <div className="space-y-2">
                  {/* Substituir a próxima linha quando houverem mais itens */}
                  {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}

                  {realCycleFilter && (realCycleFilter?.label === '2S2023' || realCycleFilter?.label === '1S2024') && (
                    <div className="-mt-10">
                      <h3 className="flex items-center text-[19px] mb-0">
                        Nível:{''}
                        <span className="ml-2 font-bold text-yellow flex items-center">
                          {getLevelTitle(summaryList?.level?.nivel)}{' '}
                          <Tippy
                            arrow={true}
                            allowHTML={true}
                            className="bg-black text-white font-thin rounded-xl p-2 tippy"
                            content={<>Nível definido.</>}
                          >
                            <div className="ml-2" tabIndex={0} aria-label={`Nível definido.`}>
                              <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                            </div>
                          </Tippy>
                        </span>
                      </h3>

                      <h3 className="flex items-center text-[19px] -mt-3 mb-10">
                        <button className="flex items-center" onClick={() => showModal('group-detail-extrato')}>
                          Grupo:{''}
                          <span className="ml-2 font-bold text-yellow flex items-center">
                            {summaryList?.level?.grupo}{' '}
                            <Tippy
                              arrow={true}
                              allowHTML={true}
                              className="bg-black text-white font-thin rounded-xl p-2 tippy"
                              content={<>O seu grupo de classificação está definido.</>}
                            >
                              <div className="ml-2" tabIndex={0} aria-label={`O seu grupo de classificação está definido.`}>
                                <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                              </div>
                            </Tippy>
                          </span>
                        </button>
                      </h3>
                    </div>
                  )}

                  <div className="grid grid-cols-1 gap-4">
                    <div
                      className="bg-maastricht-blue-3 rounded-2xl py-8 px-12 flex flex-col lg:flex-row lg:items-center justify-between"
                      tabIndex={0}
                      aria-label={`Total de Pontos do Ciclo: ${summaryList.total} pontos`}
                    >
                      <div>
                        <div className="text-yellow mb-2 text-base">Total de Pontos do Ciclo</div>
                        <div className="text-3xl">
                          <b>{FormatNumber(summaryList.total)}</b> <small className="text-base">pontos</small>
                        </div>
                      </div>
                    </div>

                    {!user?.extra.rede && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Reconhecimentos recebidos: ${summaryList?.reconhecimentos.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Reconhecimentos recebidos</div>

                            {showPreferenceMessage('recognition') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList?.reconhecimentos.total, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>

                          {summaryList?.reconhecimentos.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(1);
                                // if (showSummary && summaryData?.type === 'recognition') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.reconhecimentos.summary,
                                //     title: 'Histórico de reconhecimentos recebidos',
                                //     type: 'recognition',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'recognition' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}

                              <span className="uppercase">
                                {showSummary && summaryData?.type === 'recognition' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'recognition' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}

                    {!user?.extra.rede && userInfo?.tipo_de_acordo === 'HIBRIDO' && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Realização Destaque: ${summaryList.realizacao_destaque.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Realização Destaque</div>

                            {showPreferenceMessage('task') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList.realizacao_destaque.total, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>
                          {summaryList?.realizacao_destaque.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(2);
                                // if (showSummary && summaryData?.type === 'realization') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.realizacao_destaque.summary,
                                //     title: 'Histórico de realizações pontuadas',
                                //     type: 'realization',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'realization' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}

                              <span className="uppercase">
                                {showSummary && summaryData?.type === 'realization' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'realization' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}

                    {!user?.extra.rede && userInfo?.ecoa && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Ação ECOA: ${summaryList.acao_ecoa.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Ação ECOA</div>

                            {showPreferenceMessage('actions') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}

                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList.acao_ecoa.total, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>
                          {summaryList?.acao_ecoa.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(3);
                                // if (showSummary && summaryData?.type === 'acao_ecoa') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.acao_ecoa.summary,
                                //     title: 'Histórico de realizações pontuadas',
                                //     type: 'acao_ecoa',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'acao_ecoa' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}

                              <span className="uppercase">
                                {showSummary && summaryData?.type === 'acao_ecoa' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'acao_ecoa' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}

                    {summaryList?.destaques_cultura?.total ? (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12 flex flex-col lg:flex-row lg:items-center justify-between">
                        <div>
                          <div className="text-yellow mb-2 text-base">Destaque da cultura</div>
                          <div className="text-3xl">
                            <b>{FormatNumber(summaryList?.destaques_cultura?.total)}</b>{' '}
                            <small className="text-base">pontos</small>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    {!user?.extra.rede && (
                      <div className="bg-maastricht-blue-3 rounded-2xl py-8 px-12">
                        <div
                          className="flex flex-col lg:flex-row lg:items-center justify-between"
                          tabIndex={0}
                          aria-label={`Ações, Desafios e Campanhas: ${summaryList?.pontos_bonus.total} pontos`}
                        >
                          <div>
                            <div className="text-yellow mb-2 text-base">Ações de Engajamento</div>

                            {showPreferenceMessage('actions') && (
                              <p className="mb-2 text-yellow text-md w-[90%]">
                                Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não
                                serão convertidos em premiação.
                              </p>
                            )}
                            <div className="text-3xl">
                              <b>{FormatNumber(summaryList.pontos_bonus.total || 0, false)}</b>{' '}
                              <small className="text-base">pontos</small>
                            </div>
                          </div>
                          {summaryList?.pontos_bonus.summary.length > 0 && (
                            <button
                              className="flex items-center text-grey-dark"
                              onClick={() => {
                                scrollTop();
                                setActiveTabFiltered(4);
                                // if (showSummary && summaryData?.type === 'action') {
                                //   setShowSummary(false);
                                //   setSummaryData(undefined);
                                // } else {
                                //   setShowSummary(true);
                                //   setSummaryData({
                                //     data: summaryList?.pontos_bonus.summary,
                                //     title: 'Histórico de desafios pontuados',
                                //     type: 'action',
                                //   });
                                // }
                              }}
                            >
                              {showSummary && summaryData?.type === 'action' ? (
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                </>
                              )}
                              <span className="uppercase text-grey-dark">
                                {showSummary && summaryData?.type === 'action' ? 'Ver menos' : 'Ver mais'}
                              </span>
                            </button>
                          )}
                        </div>
                        {showSummary && summaryData?.type === 'action' && (
                          <Summary title={summaryData?.title} data={summaryData?.data} type={summaryData?.type} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === 1 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              <div className="w-full lg:flex-row">
                <div className="flex items-center m-0">
                  <button
                    aria-label={`${
                      recognitionTab === 'RECEIVED' ? 'Reconhecimentos recebidos Selecionado' : 'Reconhecimentos recebidos '
                    }`}
                    className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                      recognitionTab === 'RECEIVED'
                        ? 'bg-electric-blue text-maastricht-blue border-transparent'
                        : 'bg-transparent text-white border-white'
                    }`}
                    onClick={e => {
                      setRecognitionTab('RECEIVED');
                    }}
                  >
                    Recebidos
                  </button>
                  <button
                    aria-label={`${
                      recognitionTab === 'SENDED' ? 'Reconhecimentos Enviados Selecionado' : 'Reconhecimentos Enviados '
                    }`}
                    className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                      recognitionTab === 'SENDED'
                        ? 'bg-electric-blue text-maastricht-blue border-transparent'
                        : 'bg-transparent text-white border-white'
                    }`}
                    onClick={e => {
                      setRecognitionTab('SENDED');
                    }}
                  >
                    Enviados
                  </button>
                </div>
                <div className="mt-14">
                  {recognitionTab === 'RECEIVED' && (
                    <>
                      {/* flex justify-between items-center */}
                      <div className="flex flex-col pb-20 lg:pb-0 w-full my-14">
                        <div className="flex flex-col items-start justify-start lg:flex-row lg:justify-between lg:items-center">
                          <h3 className="text-white font-bold text-xl mb-4 lg:mb-0" tabIndex={0}>
                            Dimensões do Comportamento
                          </h3>
                        </div>
                        <Dimensions filter={filter} />
                      </div>
                      <RecognitionReceived filter={filter} />
                    </>
                  )}
                  {recognitionTab === 'SENDED' && (
                    <Recognition
                      message={editMessage}
                      filter={filter}
                      activeModal={item => {
                        setActiveEditModal(item);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {activeTab === 2 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingMissionList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingMissionList && missionList && missionList.length > 0 ? (
                <>
                  {/* TIMELINE DO EXTRATO */}
                  {realCycleFilter && (realCycleFilter?.label === '2S2023' || realCycleFilter?.label === '1S2024') && (
                    <Timeline data={missionList} cycle={realCycleFilter?.value} />
                  )}
                  <div className="space-y-2">{missionList?.map((item: any) => <PointItem key={item._id} data={item} />)}</div>
                </>
              ) : null}
              {!loadingMissionList && missionList?.length === 0 && <EmptyResult />}
            </div>
          </div>
        ) : null}

        {activeTab === 3 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingMissionListEcoa && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {!loadingMissionListEcoa && missionListEcoa && missionListEcoa.length > 0 ? (
                <>
                  <div className="space-y-2">
                    {missionListEcoa?.map((item: any) => (
                      <PointItem cycleLabel={realCycleFilter?.label} key={item._id} data={item} />
                    ))}
                  </div>
                </>
              ) : null}
              {!loadingMissionListEcoa && missionListEcoa?.length === 0 && <EmptyResult />}
            </div>
          </div>
        ) : null}

        {activeTab === 4 ? (
          <div className="mb-5">
            <div className="space-y-5 lg:p-3">
              {loadingPointsList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              {pointsList && pointsList.length > 0 ? (
                <div className="space-y-2">
                  {pointsList.map((item: any) => (
                    <PointItem key={item._id} data={item} cycleLabel={realCycleFilter?.label} />
                  ))}
                </div>
              ) : null}
              {!loadingPointsList && pointsList?.length === 0 && <EmptyResult />}
            </div>
          </div>
        ) : null}
      </div>

      <GroupDetailModalExtrato cycleLabel={realCycleFilter?.label} />

      <ExtratoDetalheModal />

      {activeEditModal && (
        <ModalEdit
          close={() => setActiveEditModal(null)}
          data={activeEditModal}
          sendMessage={message => {
            setEditMessage(message);
            setActiveEditModal(null);
          }}
        />
      )}
    </>
  );
}
